import React, { useState } from 'react';
import { MDBDataTable } from 'mdbreact';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { round } from '../../util/util';
import { faBan, faEye } from '@fortawesome/free-solid-svg-icons';
import { Overlay, Tooltip } from 'react-bootstrap';
import '../../style/DataTable.css';

const TeamsDataTable = (props) => {
  const [hoveredDisqRow, setHoveredDisqRow] = useState(null);

  const getTableRowClass = () => {
    let secondRoundSecondGroupPositions = [];
    props.teams.forEach((row) => {
      if (row.seasonScore && row.seasonScore.secondRoundGroup === 2) {
        secondRoundSecondGroupPositions.push(row.seasonScore.position);
      }
    });

    let tableRowColorClass = '';

    if (secondRoundSecondGroupPositions.length > 0) {
      tableRowColorClass += 'teamsDataTable-divide-second-round-groups ';
    }

    if (props.currentLeagueName === 'Meistriliiga (mehed)') {
      tableRowColorClass += 'teamsDataTable-men-master-league';
    } else if (props.currentLeagueName === 'Esiliiga (mehed)') {
      tableRowColorClass += 'teamsDataTable-men-premier-league';
    }

    return tableRowColorClass;
  };

  const handleMouseOver = (e) => {
    const row = e.target.closest('tr');
    if (row) {
      const marker = row.querySelector('.disqualified-row-marker');
      setHoveredDisqRow(marker || null);
    } else setHoveredDisqRow(null);
  };

  const getTeamsData = () => {
    // Sort the source teams, where `name` is still a plain string. Sorting the
    // row data instead would compare the rendered <span> elements below.
    const sortedTeams = [...props.teams].sort((a, b) => {
      const aPosition = a.seasonScore ? a.seasonScore.position : null;
      const bPosition = b.seasonScore ? b.seasonScore.position : null;

      if (aPosition === null && bPosition === null) {
        return a.name.localeCompare(b.name, 'et');
      }

      return (
        (aPosition !== null ? aPosition : Infinity) -
        (bPosition !== null ? bPosition : Infinity)
      );
    });

    let rowData = [];
    sortedTeams.map((row) =>
      rowData.push({
        position: row.seasonScore ? row.seasonScore.position : '?',
        name: row.seasonScore?.isDisqualified ? (
          <span className='disqualified-row-marker'>
            {row.name}
            <FontAwesomeIcon
              icon={faBan}
              style={{
                marginLeft: '6px',
                color: '#dc3545',
                verticalAlign: 'middle',
              }}
            />
          </span>
        ) : (
          <span>{row.name}</span>
        ),
        games: row.seasonScore ? row.seasonScore.gamesPlayed : 0,
        winnings: row.seasonScore ? row.seasonScore.gamesWon : 0,
        losses: row.seasonScore ? row.seasonScore.gamesLost : 0,
        tied: row.seasonScore ? row.seasonScore.gamesTied : 0,
        points: row.seasonScore ? row.seasonScore.points : 0,
        mp: row.seasonScore
          ? `${row.seasonScore.gamePointsWon}:${row.seasonScore.gamePointsLost}`
          : 0,
        average: row.seasonScore ? round(row.seasonScore.average, 1) : 0,
        best: row.seasonScore ? row.seasonScore.best : 0,
        toDetails: (
          <Link
            to={`/team_details?team_id=${row.id}&season_id=${props.seasonId}`}
          >
            <FontAwesomeIcon icon={faEye} />
          </Link>
        ),
      })
    );
    if (!rowData.length) {
      return null;
    }

    return {
      columns: [
        { label: 'Koht', field: 'position' },
        { label: 'Nimi', field: 'name' },
        { label: 'Mängud', field: 'games' },
        { label: 'Võidud', field: 'winnings' },
        { label: 'Kaotused', field: 'losses' },
        { label: 'Viigid', field: 'tied' },
        { label: 'Punktid', field: 'points' },
        { label: 'MP', field: 'mp' },
        { label: 'Keskmine', field: 'average' },
        { label: 'Parim', field: 'best' },
        { label: 'Detailid', field: 'toDetails' },
      ],
      rows: rowData,
    };
  };

  const tableData = getTeamsData();

  return (
    <div
      onMouseOver={handleMouseOver}
      onMouseLeave={() => setHoveredDisqRow(null)}
    >
      {tableData ? (
        <MDBDataTable
          className={`teamsDataTable ${getTableRowClass()}`}
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
      <Overlay target={hoveredDisqRow} show={!!hoveredDisqRow} placement='top'>
        {(overlayProps) => (
          <Tooltip
            id='tooltip-disqualified'
            {...overlayProps}
            style={{ ...overlayProps.style, padding: 0, fontSize: '12px' }}
          >
            Diskvalifitseeritud
          </Tooltip>
        )}
      </Overlay>
    </div>
  );
};

export default TeamsDataTable;
